import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ShippingTag from '../promotion-tag/shipping';
import * as I18n from 'src/utils/i18n';
import './index.scss';

const ArriveOn = ({ className, style, value }) => {
  if (!value) return null;

  const date = new Date(value);

  return (
    <li
      className={classnames('sub-item action-sub-item__arrive-on', className)}
      style={style}
    >
      {I18n.get('rightAction.ArriveOn') || 'Arrive on'}
      <span className="action-sub-item__arrive-on-bold">
        {date.getMonth() + 1}/{date.getDate()}
      </span>
      <ShippingTag
        type="gd"
        style={{
          marginLeft: 6,
        }}
      />
    </li>
  );
};

ArriveOn.propTypes = {
  value: PropTypes.number, // 毫秒数
};

export default ArriveOn;
